import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import './styles/responsive.css';
import Layout from './components/Layout';
import Login from './pages/Login';
import ListaBOM from './pages/ListaBOM';
import DetalleBOM from './pages/DetalleBOM';
import Usuarios from './pages/Usuarios';
import DisponibilidadMP from './pages/kpis/compras/DisponibilidadMP';
import KpisOverview from './pages/KpisOverview';
import PreciosMP from './pages/kpis/compras/PreciosMP';
import DiasColocacionOC from './pages/kpis/compras/DiasColocacionOC';
import OtifProveedor from './pages/kpis/compras/OtifProveedor';
import ConfigKgPorCarro from './pages/produccion/ConfigKgPorCarro';
import ConfigMezclaReceta from './pages/produccion/ConfigMezclaReceta';
import RechazoBarras from './pages/produccion/RechazoBarras';
import Merma from './pages/produccion/Merma';
import Produccion from './pages/produccion/Produccion';
import Rechazo from './pages/produccion/Rechazo';
import Reproceso from './pages/produccion/Reproceso';
import CumplimientoPlan from './pages/produccion/CumplimientoPlan';
import TiempoMuerto from './pages/produccion/TiempoMuerto';
import UtilizacionCapacidad from './pages/produccion/UtilizacionCapacidad';
import CoberturaPlantilla from './pages/produccion/CoberturaPlantilla';

import PorcentajeMerma from './pages/produccion/PorcentajeMerma';
import ConfigCapacidadMaxima from './pages/produccion/ConfigCapacidadMaxima';
import Mantenimiento from './pages/mantenimiento/Mantenimiento';
//logistica
import ConversionCajas from './pages/logistica/ConversionCajas';
import Caducidades from './pages/logistica/Caducidades';
import MpDesglose from './pages/logistica/MpDesglose';
import ExactitudConteo from './pages/logistica/ExactitudConteo';
import OcupacionAlmacen from './pages/logistica/OcupacionAlmacen';
import ConfigLocalidadesAlmacen from './pages/logistica/ConfigLocalidadesAlmacen';
import PepsAuditoria from './pages/logistica/PepsAuditoria';
import FillRate from './pages/logistica/FillRate';
import Otif from './pages/logistica/Otif';
import DiasInventario from './pages/logistica/DiasInventario';
import UnidadesVenta from './pages/logistica/UnidadesVenta';
import ForecastImportar from './pages/logistica/ForecastImportar';
import ForecastMapeo from './pages/logistica/ForecastMapeo';
import ForecastVsReal from './pages/logistica/ForecastVsReal';
//Calidad
import AccionesCorrectivas from './pages/calidad/AccionesCorrectivas';
import BpmIncidenciasCatalogo from './pages/calidad/BpmIncidenciasCatalogo';
import BpmCaptura from './pages/calidad/BpmCaptura';
import BpmSuspendidos from './pages/calidad/BpmSuspendidos';
import BpmReporte from './pages/calidad/BpmReporte';
import PpniPncCaptura from './pages/calidad/PpniPncCaptura';
import PpniPncPendientes from './pages/calidad/PpniPncPendientes';
import AuditoriaCaptura from './pages/calidad/AuditoriaCaptura';
import AuditoriasReporte from './pages/calidad/AuditoriasReporte';
import LotesRecepcionCaptura from './pages/calidad/LotesRecepcionCaptura';
import LotesRecepcionReporte from './pages/calidad/LotesRecepcionReporte';
import QuejasClienteCaptura from './pages/calidad/QuejasClienteCaptura';
import QuejasClienteReporte from './pages/calidad/QuejasClienteReporte';
import PiezasProducidasCaptura from './pages/calidad/PiezasProducidasCaptura';
import PpniPncReporte from './pages/calidad/PpniPncReporte';
import PpniPncCatalogos from './pages/calidad/PpniPncCatalogos';
import CostosPT from './pages/logistica/CostosPT';

function PrivateRoute({ children, soloAdmin }) {
  const { usuario, loading } = useAuth();
  if (loading) return <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', color:'#6A2C75' }}>Cargando...</div>;
  if (!usuario) return <Navigate to="/login" replace />;
  if (soloAdmin && usuario.rol !== 'admin') return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<PrivateRoute><Layout><ListaBOM /></Layout></PrivateRoute>} />
      <Route path="/bom/:id" element={<PrivateRoute><Layout><DetalleBOM /></Layout></PrivateRoute>} />
      <Route path="/usuarios" element={<PrivateRoute soloAdmin><Layout><Usuarios /></Layout></PrivateRoute>} />
      <Route path="/kpis/disponibilidad-mp" element={<PrivateRoute><Layout><DisponibilidadMP /></Layout></PrivateRoute>} />
      <Route path="/kpis" element={<PrivateRoute><Layout><KpisOverview /></Layout></PrivateRoute>} />
      <Route path="/kpis/precios-mp" element={<PrivateRoute><Layout><PreciosMP /></Layout></PrivateRoute>} />
      <Route path="/kpis/dias-colocacion-oc" element={<PrivateRoute><Layout><DiasColocacionOC /></Layout></PrivateRoute>} />
      <Route path="/kpis/otif-proveedor" element={<PrivateRoute><Layout><OtifProveedor /></Layout></PrivateRoute>} />
      <Route path="/produccion" element={<PrivateRoute><Layout><Produccion /></Layout></PrivateRoute>} />
      <Route path="/produccion/config/kg-por-carro" element={<PrivateRoute soloAdmin><Layout><ConfigKgPorCarro /></Layout></PrivateRoute>} />
      <Route path="/produccion/config/mezcla" element={<PrivateRoute><Layout><ConfigMezclaReceta /></Layout></PrivateRoute>} />
      <Route path="/produccion/rechazo-barras" element={<PrivateRoute><Layout><RechazoBarras /></Layout></PrivateRoute>} />
      <Route path="/produccion/rechazo" element={<PrivateRoute><Layout><Rechazo /></Layout></PrivateRoute>} />
      <Route path="/produccion/merma" element={<PrivateRoute><Layout><Merma /></Layout></PrivateRoute>} />
      <Route path="/produccion/reproceso" element={<PrivateRoute><Layout><Reproceso /></Layout></PrivateRoute>} />
      <Route path="/produccion/cumplimiento-plan" element={<PrivateRoute><Layout><CumplimientoPlan /></Layout></PrivateRoute>} />
      <Route path="/produccion/tiempo-muerto" element={<PrivateRoute><Layout><TiempoMuerto /></Layout></PrivateRoute>} />
      <Route path="/produccion/utilizacion-capacidad" element={<PrivateRoute><Layout><UtilizacionCapacidad /></Layout></PrivateRoute>} />
      <Route path="/produccion/porcentaje-merma" element={<PrivateRoute><Layout><PorcentajeMerma /></Layout></PrivateRoute>} />
      <Route path="/produccion/config/capacidad-maxima" element={<PrivateRoute><Layout><ConfigCapacidadMaxima /></Layout></PrivateRoute>} />
      <Route path="/produccion/cobertura-plantilla" element={<PrivateRoute><Layout><CoberturaPlantilla /></Layout></PrivateRoute>} />

      <Route path="/mantenimiento" element={<PrivateRoute><Layout><Mantenimiento /></Layout></PrivateRoute>} />
      <Route path="/logistica/conversion-cajas" element={<PrivateRoute><Layout><ConversionCajas /></Layout></PrivateRoute>} />
      <Route path="/logistica/caducidades" element={<PrivateRoute><Layout><Caducidades /></Layout></PrivateRoute>} />
      <Route path="/logistica/mp-desglose" element={<PrivateRoute><Layout><MpDesglose /></Layout></PrivateRoute>} />
      <Route path="/logistica/exactitud-conteo" element={<PrivateRoute><Layout><ExactitudConteo /></Layout></PrivateRoute>} />
      <Route path="/logistica/ocupacion" element={<PrivateRoute><Layout><OcupacionAlmacen /></Layout></PrivateRoute>} />
      <Route path="/logistica/config/localidades" element={<PrivateRoute soloAdmin><Layout><ConfigLocalidadesAlmacen /></Layout></PrivateRoute>} />
      <Route path="/logistica/peps" element={<PrivateRoute><Layout><PepsAuditoria /></Layout></PrivateRoute>} />
      <Route path="/logistica/fillrate" element={<PrivateRoute><Layout><FillRate /></Layout></PrivateRoute>} />
      <Route path="/logistica/otif" element={<PrivateRoute><Layout><Otif /></Layout></PrivateRoute>} />
      <Route path="/logistica/dias-inventario" element={<PrivateRoute><Layout><DiasInventario /></Layout></PrivateRoute>} />
      <Route path="/logistica/unidades-venta" element={<PrivateRoute><Layout><UnidadesVenta /></Layout></PrivateRoute>} />
      <Route path="/logistica/forecast/importar" element={<PrivateRoute soloAdmin><Layout><ForecastImportar /></Layout></PrivateRoute>} />
      <Route path="/logistica/forecast/mapeo" element={<PrivateRoute soloAdmin><Layout><ForecastMapeo /></Layout></PrivateRoute>} />
      <Route path="/logistica/forecast" element={<PrivateRoute><Layout><ForecastVsReal /></Layout></PrivateRoute>} />
      <Route path="/logistica/costos-pt" element={<PrivateRoute><Layout><CostosPT /></Layout></PrivateRoute>} />
         {/* Calidad */}
      <Route path="/calidad/acciones-correctivas" element={<PrivateRoute><Layout><AccionesCorrectivas /></Layout></PrivateRoute>} />
      <Route path="/calidad/bpm-incidencias-catalogo" element={<PrivateRoute><Layout><BpmIncidenciasCatalogo /></Layout></PrivateRoute>} />
      <Route path="/calidad/bpm-captura" element={<PrivateRoute><Layout><BpmCaptura /></Layout></PrivateRoute>} />
      <Route path="/calidad/bpm-suspendidos" element={<PrivateRoute><Layout><BpmSuspendidos /></Layout></PrivateRoute>} />
      <Route path="/calidad/bpm-reporte" element={<PrivateRoute><Layout><BpmReporte /></Layout></PrivateRoute>} />
      <Route path="/calidad/ppni-pnc-captura" element={<PrivateRoute><Layout><PpniPncCaptura /></Layout></PrivateRoute>} />
      <Route path="/calidad/ppni-pnc-pendientes" element={<PrivateRoute><Layout><PpniPncPendientes /></Layout></PrivateRoute>} />
      <Route path="/calidad/auditoria-captura" element={<PrivateRoute><Layout><AuditoriaCaptura /></Layout></PrivateRoute>} />
      <Route path="/calidad/auditorias-reporte" element={<PrivateRoute><Layout><AuditoriasReporte /></Layout></PrivateRoute>} />
      <Route path="/calidad/lotes-recepcion-captura" element={<PrivateRoute><Layout><LotesRecepcionCaptura /></Layout></PrivateRoute>} />
      <Route path="/calidad/lotes-recepcion-reporte" element={<PrivateRoute><Layout><LotesRecepcionReporte /></Layout></PrivateRoute>} />
      <Route path="/calidad/quejas-cliente-captura" element={<PrivateRoute><Layout><QuejasClienteCaptura /></Layout></PrivateRoute>} />
      <Route path="/calidad/quejas-cliente-reporte" element={<PrivateRoute><Layout><QuejasClienteReporte /></Layout></PrivateRoute>} />
      <Route path="/calidad/piezas-producidas-captura" element={<PrivateRoute><Layout><PiezasProducidasCaptura /></Layout></PrivateRoute>} />
      <Route path="/calidad/ppni-pnc-reporte" element={<PrivateRoute><Layout><PpniPncReporte /></Layout></PrivateRoute>} />
      <Route path="/calidad/ppni-pnc-catalogos" element={<PrivateRoute><Layout><PpniPncCatalogos /></Layout></PrivateRoute>} />
      
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return <AuthProvider><AppRoutes /></AuthProvider>;
}